import React, { Component } from 'react'
import axios from "axios";
import { API_BASE_URL, PIN_CODE_PATTERN, TYPE_SUCCESS, TYPE_FAIL, INTERVAL, WEB_APP_URL, FLOW_COLUMN_SELECTION_TRUE_VALUE, FLOW_COLUMN_SELECTION_OPTIONS, FLOW_COLUMN_LIST, LEVEL_COLUMN_LIST, LEVEL_COLUMN_SELECTION_TRUE_VALUE, LEVEL_COLUMN_SELECTION_OPTIONS } from "assets/constants/Constants";
import { SITE_ICON, COPY_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Select from 'react-select';

export class CreateSitePage extends Component {
    constructor(props) {
        super(props)
        const adminDefaults = {};
        const readerDefaults = {};
        const flowColumns = FLOW_COLUMN_LIST
        flowColumns.forEach(column => {
            adminDefaults[column.field] = true;
            readerDefaults[column.field] = true;
        });

        const levelSuperAdminDefaults = {};
        const levelAdminDefaults = {};
        const levelReaderDefaults = {};
        const levelColumns = LEVEL_COLUMN_LIST;
        levelColumns.forEach(column => {
            levelSuperAdminDefaults[column.field] = true;
            levelAdminDefaults[column.field] = true;
            levelReaderDefaults[column.field] = true;
        });

        const editData = this.props.history.location.state;
        console.log("editData::", editData)
        const columnAccessData = editData && editData.flow_column_access ? editData.flow_column_access : { admin: adminDefaults, reader: readerDefaults };
        const levelColumnAccessData = editData && editData.level_column_access ? {
            superadmin: editData.level_column_access.superadmin || levelSuperAdminDefaults,
            admin: editData.level_column_access.admin || levelAdminDefaults,
            reader: editData.level_column_access.reader || levelReaderDefaults
        } : { superadmin: levelSuperAdminDefaults, admin: levelAdminDefaults, reader: levelReaderDefaults };
        const tempDeviceType = editData && Array.isArray(editData.device_type_value) ? editData.device_type_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        const tempsubModuleFeatureValue = editData && Array.isArray(editData.sub_module_feature_value) ? editData.sub_module_feature_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        const amiSystemReceiverTypeValue = editData && Array.isArray(editData.ami_system_receiver_type_value) ? editData.ami_system_receiver_type_value.filter(item => item.length > 0).map(item => ({ label: item, value: item })) : [];
        this.state = {
            isLoading: true,
            defaultBackgroundImageOrUplodedImageType: editData === null || editData.defaultImage_uploadedImage === undefined || editData.defaultImage_uploadedImage === "" || editData.defaultImage_uploadedImage === null ? "" : (editData && editData.defaultImage_uploadedImage.base64Data) ? this.getFileNameFromEditData(editData.defaultImage_uploadedImage) : (editData && editData.defaultImage_uploadedImage) ? this.getUrleFromEditData(editData.defaultImage_uploadedImage) : editData.defaultImage_uploadedImage,
            backgroundImageSelectedType: editData === null ? "" : editData.background_image_selected_type,
            clientName: editData === null ? null : editData.client_name,
            clientID: editData === null ? "" : editData.client_id,
            primaryLogoImage: editData === null || editData.client_logoImage_primary === undefined || editData.client_logoImage_primary === "" || editData.client_logoImage_primary === null ? "" : (editData.client_logoImage_primary.base64Data) ? this.getFileNameFromEditData(editData.client_logoImage_primary) : (editData.client_logoImage_primary) ? this.getUrleFromEditData(editData.client_logoImage_primary) : "",
            secondaryLogoImage: editData === null || editData.client_logoImage_secondary === undefined || editData.client_logoImage_secondary === "" || editData.client_logoImage_secondary === null ? "" : (editData.client_logoImage_secondary.base64Data) ? this.getFileNameFromEditData(editData.client_logoImage_secondary) : (editData.client_logoImage_secondary) ? this.getUrleFromEditData(editData.client_logoImage_secondary) : "",
            siteId: editData === null ? null : editData._id,
            siteName: editData === null ? "" : editData.site_name,
            siteStreet: editData === null ? "" : editData.street,
            siteCity: editData === null ? "" : editData.city,
            sitePincode: editData === null ? "" : editData.pincode,
            backendURL: editData === null ? "" : editData.backend_url,
            siteInactive: editData === null ? "" : editData.site_inactive,
            siteTodaysRedaingsToCheck: editData === null ? "" : editData.site_todays_readings_check,
            copiedIconClass: "",
            siteBackGroundImageSelectedList: [
                { value: "power plant", label: "Power plant" },
                { value: "hydro plant", label: "Hydro plant" },
                { value: "electricity plant", label: "Electricity plant" },
            ],
            siteBackGroundImageSelecteTypeList: [
                { value: "default images", label: "Default images" },
                { value: "upload", label: "Upload" }
            ],
            systemTypesList: [
                { value: "amr systems", label: "Amr Systems" },
                { value: "ami systems", label: "Ami Systems" },
                { value: "Ami + Remote Configuration", label: "Ami + Remote Configuration" },
            ],
            deviceTypeValue: editData === null ? [] : tempDeviceType,
            systemTypeValue: editData === null ? "" : { label: editData.system_type_value, value: editData.system_type_value },
            amiSystemReceiverType: editData === null ? [] : amiSystemReceiverTypeValue,
            amrSystemReceiverType: editData === null ? [] : { value: "Gateway + Aqualink", label: "Gateway + Aqualink" },
            remoteSystemReceiverType: editData === null ? [] : { value: "Mqtt Devices", label: "Mqtt Devices" },
            amiSystemReceiverTypeList: [
                { value: "Gateway", label: "Gateway" },
                { value: "Mqtt Devices", label: "Mqtt Devices" },
            ],
            subModuleFeatureValue: editData === null ? [] : tempsubModuleFeatureValue,
            deviceTypesList: [
                { value: "Flow", label: "Flow" },
                { value: "Pressure", label: "Pressure" },
                { value: "Level", label: "Level" },
                { value: "Temperature", label: "Temperature" },
                { value: "OHT Solution", label: "OHT Solution" }
            ],
            deviceTypesListRemoteConfiguration: [
                { value: "Flow", label: "Flow" },
            ],
            flowColumnSelecetionValue: editData === null ? [] : { label: editData.flow_column_selection, value: editData.flow_column_selection },
            levelColumnSelecetionValue: (editData === null || !editData.level_column_selection) ? [] : { label: editData.level_column_selection, value: editData.level_column_selection },
            flowColumnSelecetionOptions: FLOW_COLUMN_SELECTION_OPTIONS,
            subModuleFeatureList: [
                { value: "location", label: "Location" },
                { value: "customeradd-billingcycle", label: "Customer Add - Billing Cycle" },
            ],
            flowUnitValue: editData === null ? "" : { label: editData.flow_unit_value, value: editData.flow_unit_value },
            pressureUnitValue: editData === null ? "" : { label: editData.pressure_unit_value, value: editData.pressure_unit_value },
            levelUnitValue: editData === null ? "" : { label: editData.level_unit_value, value: editData.level_unit_value },
            temperatureUnitValue: editData === null ? "" : { label: editData.temperature_unit_value, value: editData.temperature_unit_value },
            flowUnitTypesList: [
                { value: "m³", label: "M³" },
                { value: "liter", label: "Liter" }
            ],
            pressureUnitTypesList: [
                { value: "bar", label: "Bar" },
                { value: "kg/cm²", label: "Kg/cm²" },
                { value: "mmh2o", label: "mmH2O" }
            ],
            levelUnitTypesList: [
                { value: "meter", label: "Meter" },
                { value: "mm", label: "MM" }
            ],
            temperatureUnitTypesList: [
                { value: "°c", label: "°C" },
                { value: "°f", label: "°F" }
            ],
            deviceTypeDisable: editData === null ? true : false,
            flowUnitDisable: editData === null ? true : false,
            pressureUnitDisable: editData === null ? true : false,
            levelUnitDisable: editData === null ? true : false,
            temperatureUnitDisable: editData === null ? true : false,
            error: {},
            columnAccess: columnAccessData,
            levelColumnAccess: levelColumnAccessData,
            activeTab: 'siteDetails'
        }
    }

    async componentDidMount() {
        const siteData = await axios(`${API_BASE_URL}/site`);
        this.setState({
            siteList: siteData.data.result,
            isLoading: false,
        });

        const editDataForDowImage = this.props.history.location.state;
        const getCleanFileName = (url) => {
            const decodedUrl = decodeURIComponent(url);
            let fileName = decodedUrl.split("/").pop();

            if (fileName.endsWith('}')) {
                fileName = fileName.slice(0, -1);
            }

            const parts = fileName.split('_');
            if (parts.length > 1) {
                return parts.pop();
            }

            return fileName;
        };

        if (editDataForDowImage) {
            if (editDataForDowImage.defaultImage_uploadedImage) {
                const imageData = editDataForDowImage.defaultImage_uploadedImage;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLink: imageData,
                        downloadFileName: fileName,
                        defaultBackgroundImageOrUplodedImageType: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLink: fileUrl,
                        downloadFileName: fileName,
                        defaultBackgroundImageOrUplodedImageType: { base64Data, fileName }
                    });
                }
            }

            if (editDataForDowImage.client_logoImage_primary) {
                const imageData = editDataForDowImage.client_logoImage_primary;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLinkLogo1: imageData,
                        downloadFileNameLogo1: fileName,
                        primaryLogoImage: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLinkLogo1: fileUrl,
                        downloadFileNameLogo1: fileName,
                        primaryLogoImage: { base64Data, fileName }
                    });
                }
            }

            if (editDataForDowImage.client_logoImage_secondary) {
                const imageData = editDataForDowImage.client_logoImage_secondary;

                if (typeof imageData === "string") {
                    const fileName = getCleanFileName(imageData);
                    this.setState({
                        downloadLinkLogo2: imageData,
                        downloadFileNameLogo2: fileName,
                        secondaryLogoImage: { url: imageData, fileName }
                    });
                } else if (typeof imageData === "object" && imageData.base64Data) {
                    const { base64Data, fileName } = imageData;
                    const { fileUrl } = this.base64ToFile({ base64Data, fileName });
                    this.setState({
                        downloadLinkLogo2: fileUrl,
                        downloadFileNameLogo2: fileName,
                        secondaryLogoImage: { base64Data, fileName }
                    });
                }
            }
        }

    }
    base64ToFile = ({ base64Data, fileName }) => {
        const base64String = base64Data.split(',')[1];
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const fileUrl = URL.createObjectURL(blob);
        return { fileUrl, fileName };
    };

    getFileNameFromEditData = (editData) => {
        if (editData && editData.fileName) {
            return editData.fileName;
        }
        return "No file selected";
    };

    getUrleFromEditData = (editData) => {
        console.log("background image", editData);
        if (editData && typeof editData === 'string') {
            // If it's already a URL, return the full URL, not just filename
            if (editData.startsWith('https')) {
                return editData; // Return full URL
            }
            // If it's just a filename, extract it
            const fileName = editData.replace(/^.*[\\/]/, '');
            console.log("Extracted filename:", fileName);
            return fileName;
        }
        return "No file selected";
    };

    siteNameHandler = (event) => {
        this.setState({
            siteName: event.target.value
        });
    }

    siteStreetHandler = (event) => {
        this.setState({
            siteStreet: event.target.value
        });
    }

    siteCityHandler = (event) => {
        this.setState({
            siteCity: event.target.value
        });
    }

    sitePincodeHandler = (event) => {
        this.setState({
            sitePincode: event.target.value
        });
    }

    siteInactiveHandler = (event) => {
        this.setState({
            siteInactive: event.target.value
        });
    }

    siteTodaysRedaingsToCheckHandler = (event) => {
        this.setState({
            siteTodaysRedaingsToCheck: event.target.value
        });
    }

    isFormValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.siteName) {
            isValid = false;
            error.siteName = "Please enter site name";
        }
        if (!this.state.siteStreet) {
            isValid = false;
            error.siteStreet = "Please enter site street";
        }
        if (!this.state.siteCity) {
            isValid = false;
            error.siteCity = "Please enter site city";
        }
        if (!this.state.sitePincode) {
            isValid = false;
            error.sitePincode = "Please enter site pincode";
        }
        if (this.state.sitePincode !== "undefined") {
            if (!PIN_CODE_PATTERN.test(this.state.sitePincode)) {
                isValid = false;
                error.sitePincode = "Please enter valid Pincode";
            }
        }

        if (!this.state.clientName) {
            isValid = false;
            error.clientName = "Please enter client name";
        }

        if (!this.state.clientID) {
            isValid = false;
            error.clientID = "Please enter clientID";
        }


        if (!this.state.siteInactive) {
            isValid = false;
            error.siteInactive = "Please enter time";
        }

        if (!this.state.systemTypeValue) {
            isValid = false;
            error.systemTypeValue = "Please select system type";
        }

        if (this.state.systemTypeValue?.value === "ami systems") {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select  device type";
            }

            if (!this.state.amiSystemReceiverType || this.state.amiSystemReceiverType.length === 0) {
                isValid = false;
                error.amiSystemReceiverType = "Please select ami systems receiver type";
            }

        }

        if (this.state.systemTypeValue?.value === "amr systems") {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select  device type";
            }
        }

        if (this.state.systemTypeValue?.value === "Ami + Remote Configuration") {
            if (!this.state.deviceTypeValue || this.state.deviceTypeValue.length === 0) {
                isValid = false;
                error.deviceTypeValue = "Please select device type";
            }
        }

        if (this.state.systemTypeValue?.value === "ami systems") {
            if (this.state.flowColumnSelecetionValue.length === 0) {
                isValid = false;
                error.flowColumnSelecetionValue = "Please select flow columns";
            }
        }
        // if (!this.state.siteTodaysRedaingsToCheck) {
        //     isValid = false;
        //     error.siteTodaysRedaingsToCheck = "Please enter time";
        // }

        this.setState({
            error
        });
        console.log("error", error)
        return isValid;
    }

    toBase64 = async (file) => {
        if (file && file.base64Data && file.fileName) {
            this.setState({
                base64Data: file.base64Data,
                fileName: file.fileName
            }, () => {
                console.log("State updated:", this.state.base64Data, this.state.fileName);
            });
            return;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result;
                const fileName = file.name;
                resolve({
                    base64Data: base64Data,
                    fileName: fileName
                });
            };

            reader.onerror = (error) => {
                console.error("FileReader error:", error);
                reject(error);
            };

            reader.readAsDataURL(file);
        });
    };



    cancelHandler = (event) => {
        this.props.history.push("/sites-page");
    }

    copyHandler = (copiedText, isSuccessful) => {
        if (isSuccessful) {
            console.log(`Copied: ${copiedText}`);
            this.setState({ copiedIconClass: 'copied-text' });

            setTimeout(() => {
                this.setState({ copiedIconClass: " " });
            }, 3500);
            ShowToast('Text copied!', TYPE_SUCCESS, INTERVAL, this.props, "/create-site-page");
        } else {
            console.error('Copy failed');
        }
    };

    siteBackGroundChangeHandler = (event) => {
        this.setState({
            defaultBackgroundImageOrUplodedImageType: event.target.value,
        });
    }

    siteBackGroundChangeHandlerUpload = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileSize = file.size
            const maxSize = 2 * 1024 * 1024; // 2 MB in bytes

            if (fileSize > maxSize) {
                alert('File size should not exceed 100KB.');
                this.setState({ defaultBackgroundImageOrUplodedImageType: "", error: 'File size exceeds 100KB.' });
                event.target.value = "";
            } else {
                this.setState({ defaultBackgroundImageOrUplodedImageType: file, error: '' });
            }
        } else {
            this.setState({ defaultBackgroundImageOrUplodedImageType: "", error: '' });
        }
    }


    siteBackGroundChangeTypesHandler = (event) => {
        this.setState({
            backgroundImageSelectedType: event.target.value,
        })
    }

    systemTypesHandler = (event) => {
        this.setState({
            systemTypeValue: event,
            deviceTypeDisable: event.label === "Ami Systems" || event.label === "Amr Systems" || event.label === "Ami + Remote Configuration" ? false : true,
            deviceTypeValue: [],
            flowUnitDisable: event.label === "Ami + Remote Configuration" ? false : true,
            flowUnitValue: [],
            pressureUnitValue: [],
            levelUnitValue: [],
            temperatureUnitValue: [],
            amrSystemReceiverType: [{ value: "Gateway + Aqualink", label: "Gateway + Aqualink" }],
            remoteSystemReceiverType: [{ value: "Mqtt Devices", label: "Mqtt Devices" }],
            flowUnitDisable: event.label === "Ami Systems" || event.label === "Amr Systems" || event.label === "Ami + Remote Configuration" ? true : false,
            pressureUnitDisable: event.label === "Ami Systems" || event.label === "Amr Systems" || event.label === "Ami + Remote Configuration" ? true : false,
            levelUnitDisable: event.label === "Ami Systems" || event.label === "Amr Systems" || event.label === "Ami + Remote Configuration" ? true : false,
            temperatureUnitDisable: event.label === "Ami Systems" || event.label === "Amr Systems" || event.label === "Ami + Remote Configuration" ? true : false,

        })
    }

    amiSystemReceiverTypesHandler = (event) => {
        this.setState({
            amiSystemReceiverType: event
        })
    }

    deviceTypesHandler = (selectedOptions) => {
        console.log("device-type", selectedOptions);

        const isOHTSolutionSelected = selectedOptions.some(option => option.value === 'oht solution');
        console.log("isOHTSolutionSelected::", isOHTSolutionSelected)

        const selectedTypes = new Set(selectedOptions.map(option => option.label));
        console.log("selectedTypes::", selectedTypes)

        this.setState({
            deviceTypeValue: selectedOptions || "",
            flowUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Flow'),
            pressureUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Pressure'),
            levelUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Level'),
            temperatureUnitDisable: isOHTSolutionSelected ? false : !selectedTypes.has('Temperature'),

            flowUnitValue: isOHTSolutionSelected ? this.state.flowUnitValue : (!selectedTypes.has('Flow') ? [] : this.state.flowUnitValue),
            pressureUnitValue: isOHTSolutionSelected ? this.state.pressureUnitValue : (!selectedTypes.has('Pressure') ? [] : this.state.pressureUnitValue),
            levelUnitValue: isOHTSolutionSelected ? this.state.levelUnitValue : (!selectedTypes.has('Level') ? [] : this.state.levelUnitValue),
            temperatureUnitValue: isOHTSolutionSelected ? this.state.temperatureUnitValue : (!selectedTypes.has('Temperature') ? [] : this.state.temperatureUnitValue)
        });
    }

    flowColumnSelectionChangeHandler = (item) => {
        this.setState({
            flowColumnSelecetionValue: item
        })
    }

    levelColumnSelectionChangeHandler = (item) => {
        this.setState({
            levelColumnSelecetionValue: item
        })
    }

    flowUnittypesHandler = (event) => {
        this.setState({
            flowUnitValue: event
        })
    }

    pressureUnitTypesHandler = (event) => {
        this.setState({
            pressureUnitValue: event
        })
    }

    levelUnitTypesHandler = (event) => {
        this.setState({
            levelUnitValue: event
        })
    }

    temperatureUnitTypesHandler = (event) => {
        this.setState({
            temperatureUnitValue: event
        })
    }

    siteClinetNameHandaler = (event) => {
        this.setState({
            clientName: event.target.value
        })
    }
    siteClinetIDHandaler = (event) => {
        this.setState({
            clientID: event.target.value
        })
    }

    sitePrimaryLogoImageChangeHandler = (event) => {
        this.setState({
            primaryLogoImage: event.target.files[0],
        })
    }

    siteSecondaryLogoImageChangeHandler = (event) => {
        this.setState({
            secondaryLogoImage: event.target.files[0],
        })
    }

    subModuleFeatureHandler = (event) => {
        this.setState({
            subModuleFeatureValue: event,
        })
    }

    renderBackGroundImageSelectTypesOptions = () => {
        if (this.state.siteBackGroundImageSelecteTypeList.length > 0) {
            return this.state.siteBackGroundImageSelecteTypeList.map((backgroundimageTypeNameSelectItem, index) => {
                let isSelected = false;
                if (backgroundimageTypeNameSelectItem.value === this.state.backgroundImageSelectedType) {
                    isSelected = true;
                }
                return (
                    <option value={backgroundimageTypeNameSelectItem.value} selected={isSelected} key={backgroundimageTypeNameSelectItem.value} className="option-text-color"> {backgroundimageTypeNameSelectItem.label} </option>
                )
            });
        }
        else {
            return <option disabled> No Data Found</option>
        }
    }

    renderBackGroundImageSelectOptions = () => {
        if (this.state.siteBackGroundImageSelectedList.length > 0) {
            return this.state.siteBackGroundImageSelectedList.map((backgroundimageNameSelectItem, index) => {
                let isSelected = false;
                if (backgroundimageNameSelectItem.value === this.state.defaultBackgroundImageOrUplodedImageType) {
                    isSelected = true;
                }
                return (
                    <option value={backgroundimageNameSelectItem.value} selected={isSelected} key={backgroundimageNameSelectItem.value} className="option-text-color"> {backgroundimageNameSelectItem.label} </option>
                )
            });
        }
        else {
            return <option disabled> No Data Found</option>
        }
    }

    addSiteHandler = async (event) => {
        event.preventDefault();
        if (this.isFormValid()) {
            this.setState({ isLoading: true, });


            let primaryLogoImageData = null;
            const primaryLogoImage = this.state.primaryLogoImage;

            if (!primaryLogoImage || primaryLogoImage === "" || primaryLogoImage === "null") {
                primaryLogoImageData = null;
            }
            else if (typeof primaryLogoImage === "string") {
                primaryLogoImageData = primaryLogoImage;
            }
            else if (primaryLogoImage instanceof File) {
                const result = await this.toBase64(primaryLogoImage);
                primaryLogoImageData = {
                    base64Data: result.base64Data,
                    fileName: result.fileName
                };
            }
            else if (primaryLogoImage && typeof primaryLogoImage === "object") {
                if (primaryLogoImage.base64Data && primaryLogoImage.fileName) {
                    primaryLogoImageData = {
                        base64Data: primaryLogoImage.base64Data,
                        fileName: primaryLogoImage.fileName
                    };
                } else if (primaryLogoImage.url) {
                    primaryLogoImageData = primaryLogoImage.url;
                }
            }

            let secondaryLogoImageData = null;
            const secondaryLogoImage = this.state.secondaryLogoImage;

            if (!secondaryLogoImage || secondaryLogoImage === "" || secondaryLogoImage === "null") {
                secondaryLogoImageData = null;
            }
            else if (typeof secondaryLogoImage === "string") {
                secondaryLogoImageData = secondaryLogoImage;
            }
            else if (secondaryLogoImage instanceof File) {
                const result = await this.toBase64(secondaryLogoImage);
                secondaryLogoImageData = {
                    base64Data: result.base64Data,
                    fileName: result.fileName
                };
            }
            else if (secondaryLogoImage && typeof secondaryLogoImage === "object") {
                if (secondaryLogoImage.base64Data && secondaryLogoImage.fileName) {
                    secondaryLogoImageData = {
                        base64Data: secondaryLogoImage.base64Data,
                        fileName: secondaryLogoImage.fileName
                    };
                } else if (secondaryLogoImage.url) {
                    secondaryLogoImageData = secondaryLogoImage.url;
                }
            }

            let backgroundImageData = null;
            const backgroundImage = this.state.defaultBackgroundImageOrUplodedImageType;

            if (this.state.backgroundImageSelectedType === "upload") {
                if (!backgroundImage || backgroundImage === "" || backgroundImage === "null") {
                    backgroundImageData = null;
                }
                else if (typeof backgroundImage === "string") {
                    backgroundImageData = backgroundImage;
                }
                else if (backgroundImage instanceof File) {
                    const result = await this.toBase64(backgroundImage);
                    backgroundImageData = {
                        base64Data: result.base64Data,
                        fileName: result.fileName
                    };
                }
                else if (backgroundImage && typeof backgroundImage === "object") {
                    if (backgroundImage.base64Data && backgroundImage.fileName) {
                        backgroundImageData = {
                            base64Data: backgroundImage.base64Data,
                            fileName: backgroundImage.fileName
                        };
                    } else if (backgroundImage.url) {
                        backgroundImageData = backgroundImage.url;
                    }
                }
            } else if (this.state.backgroundImageSelectedType === "default images") {
                backgroundImageData = backgroundImage;
            }

            const deviceDataValues = Array.isArray(this.state.deviceTypeValue) ? this.state.deviceTypeValue.map(item => item.label) : [];
            const subModuleFeatureValue = Array.isArray(this.state.subModuleFeatureValue) ? this.state.subModuleFeatureValue.map((item) => { return item.label }) : [];
            const amiSystemReceiverTypeValue = Array.isArray(this.state.amiSystemReceiverType) ? this.state.amiSystemReceiverType.map((item) => { return item.label }) : [];
            const amrSystemsReceiverTypeValue = Array.isArray(this.state.amrSystemReceiverType) && this.state.amrSystemReceiverType.length > 0 ? this.state.amrSystemReceiverType[0].label : "";
            const remoteSystemReceiverTypeValue = Array.isArray(this.state.remoteSystemReceiverType) && this.state.remoteSystemReceiverType.length > 0 ? this.state.remoteSystemReceiverType[0].label : "";

            const requestParameter = {
                siteName: this.state.siteName,
                siteStreet: this.state.siteStreet,
                siteCity: this.state.siteCity,
                sitePincode: this.state.sitePincode,
                defaultBackgroundImageOrUplodedImageType: backgroundImageData,
                backgroundImageSelectedType: this.state.backgroundImageSelectedType,
                clientName: this.state.clientName,
                clientID: this.state.clientID,
                systemTypeValue: this.state.systemTypeValue.label,
                subModuleFeatureValue: subModuleFeatureValue,
                deviceTypeValue: deviceDataValues,
                amiAmrRemoteSystemReceiverTypeValue: this.state.systemTypeValue.label === "Ami Systems" ? amiSystemReceiverTypeValue : this.state.systemTypeValue.label === "Amr Systems" ? amrSystemsReceiverTypeValue : this.state.systemTypeValue.label === "Ami + Remote Configuration" ? remoteSystemReceiverTypeValue : "",
                flowUnitValue: this.state.flowUnitValue.label,
                pressureUnitValue: this.state.pressureUnitValue.label,
                levelUnitValue: this.state.levelUnitValue.label,
                temperatureUnitValue: this.state.temperatureUnitValue.label,
                primaryLogoImage: primaryLogoImageData,
                secondaryLogoImage: secondaryLogoImageData,
                siteInactive: this.state.siteInactive,
                siteTodaysRedaingsToCheck: this.state.siteTodaysRedaingsToCheck,
                backendURL: this.state.backendURL,
                flowColumnSelection: this.state.flowColumnSelecetionValue.label,
                columnAccess: this.state.flowColumnSelecetionValue.label === FLOW_COLUMN_SELECTION_TRUE_VALUE ? this.state.columnAccess : null,
                levelColumnSelection: this.state.levelColumnSelecetionValue?.label,
                levelColumnAccess: this.state.levelColumnSelecetionValue?.label === LEVEL_COLUMN_SELECTION_TRUE_VALUE ? this.state.levelColumnAccess : null
            }
            let siteResponse = null;
            if (this.state.siteId === null) {
                siteResponse = await axios.post(`${API_BASE_URL}/site`, requestParameter);
            }
            else {
                siteResponse = await axios.put(`${API_BASE_URL}/site/${this.state.siteId}`, requestParameter);
            }
            const tempSiteId = this.state.siteId;
            if (siteResponse.status === 200) {
                this.setState({
                    siteId: null,
                    siteName: "",
                    siteList: "",
                    siteCity: "",
                    sitePincode: "",
                    backendURL: ""
                }, () => {
                    if (tempSiteId === null) {
                        ShowToast('Site created successfully', TYPE_SUCCESS, INTERVAL, this.props, "/sites-page");
                    }
                    else {
                        ShowToast('Site updated successfully', TYPE_SUCCESS, INTERVAL, this.props, "/sites-page");
                    }
                    this.props.history.push("/sites-page");
                });
            }
        }
    }

    checkIfClientIdAlreadyPresent = async (event) => {
        event.preventDefault();
        const clientID = event.target.value
        const siteDataBasedOnClientId = await axios(`${API_BASE_URL}/site/${clientID}`);
        if (siteDataBasedOnClientId.data.length > 0) {
            ShowToast(`This ${clientID} clientID  is already created`, TYPE_FAIL, INTERVAL, this.props, "");
            this.setState({
                clientID: ""
            })
            return;
        }
    }

    handleToggle = (role, field) => {

        this.setState(prev => ({
            columnAccess: {
                ...prev.columnAccess,
                [role]: {
                    ...prev.columnAccess[role],
                    [field]: !prev.columnAccess[role][field]
                }
            }
        }), () => {
            console.log("columnAccess::", this.state.columnAccess)
        });

    };

    handleLevelToggle = (role, field) => {
        this.setState(prev => ({
            levelColumnAccess: {
                ...prev.levelColumnAccess,
                [role]: {
                    ...prev.levelColumnAccess[role],
                    [field]: !prev.levelColumnAccess[role][field]
                }
            }
        }), () => {
            console.log("levelColumnAccess::", this.state.levelColumnAccess)
        });
    };

    render() {
        const editData = this.props.history.location.state;
        const flowColumns = [
            { label: "Zone", field: "zone" },
            { label: "Subzone", field: "subzone" },
            { label: "Location/Tag", field: "location" },
            { label: "Meter Serial Number", field: "meter_serial_no" },
            { label: "Yesterday Consumption", field: "yesterdays_comspution" },
            { label: "Today Consumption", field: "todays_comspution" },
            { label: "Totalizer", field: "totalizer" },
            { label: "Unit", field: "unit" },
            { label: "Flowrate", field: "flowrate" },
            { label: "Valve Status", field: "valve_status" },
            { label: "Network Time Stamp", field: "receive_date_time" },
            { label: "Status", field: "status" }
        ];
        const levelColumns = LEVEL_COLUMN_LIST;
        if (this.state.isLoading) {
            return (
                <Spinner />
            )
        }
        else {
            return (
                <div className="main-content">
                    <div className="back">
                        <ul className="breadcrumb1">
                            <li><a href="/sites-page">Site Master</a></li>
                            {
                                this.state.siteId === null ? (
                                    <li>Add New Site</li>
                                ) : (
                                    <li>Edit Site</li>
                                )
                            }
                        </ul>
                    </div>
                    <div className="add-site-main-view">
                        <div className="mx-auto text-left border create-site-div">
                            <form className="pt-1">
                                <div className="site-icon-wrapper">
                                    <h4>{this.state.siteId ? "Edit Site" : "Add New Site"}</h4>
                                    <i className={`${SITE_ICON} list-table-icon`}></i>
                                </div>

                                <ul className="nav nav-tabs site-tabs mb-4 px-3" role="tablist">
                                    <li className="nav-item">
                                        <a className={`nav-link ${this.state.activeTab === 'siteDetails' ? 'active font-weight-bold' : ''}`} onClick={() => this.setState({ activeTab: 'siteDetails' })} role="tab" style={{ cursor: 'pointer' }}>Site Details</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={`nav-link ${this.state.activeTab === 'columnAccess' ? 'active font-weight-bold' : ''}`} onClick={() => this.setState({ activeTab: 'columnAccess' })} role="tab" style={{ cursor: 'pointer' }}>Column Access</a>
                                    </li>
                                </ul>

                                <div className="tab-content w-100">
                                    {this.state.activeTab === 'siteDetails' && (
                                        <>
                                            <div className="input-label-group w-100">
                                                <label className="form-label">Site Name <span className="text-danger">*</span></label>
                                                <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteName} onChange={this.siteNameHandler} placeholder="Enter Site Name" />
                                                <div className="text-danger error-msg">
                                                    {this.state.error.siteName}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site Street <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteStreet} onChange={this.siteStreetHandler} placeholder="Enter Site Street" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteStreet}
                                                    </div>
                                                </div>
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site City<span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.siteCity} onChange={this.siteCityHandler} placeholder="Enter Site City" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteCity}
                                                    </div>
                                                </div>
                                                <div className="input-label-group col-md-4">
                                                    <label className="form-label">Site Pincode <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.sitePincode} onChange={this.sitePincodeHandler} placeholder="Enter Site Pincode" maxLength="6" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.sitePincode}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6" id="custom-dropdown">
                                                    <label className="form-label">Site Background image types </label>
                                                    <select
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.siteBackGroundChangeTypesHandler}
                                                        value={this.state.backgroundImageSelectedType}
                                                    //placeholder="Select types"
                                                    >
                                                        <option value="" disabled >Select types</option>
                                                        {
                                                            this.renderBackGroundImageSelectTypesOptions()
                                                        }
                                                    </select>
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageOrUplodedImageType}
                                                    </div>
                                                </div>
                                                {
                                                    this.state.backgroundImageSelectedType === "default images" ? (
                                                        <div className="input-label-group col-md-6" id="custom-dropdown">
                                                            <label className="form-label">Site Background image</label>
                                                            <select
                                                                className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                                onChange={this.siteBackGroundChangeHandler}
                                                                value={this.state.defaultBackgroundImageOrUplodedImageType}
                                                            //placeholder="Select images"
                                                            >
                                                                <option value="" disabled >Select images</option>
                                                                {
                                                                    this.renderBackGroundImageSelectOptions()
                                                                }
                                                            </select>
                                                            <div className="text-danger error-msg">
                                                                {this.state.error.backgroundImage}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        this.state.backgroundImageSelectedType === "upload" && (
                                                            <div className="input-label-group col-md-6">
                                                                <label className="form-label">Upload Site Background image <span className="text-danger">(Max 2MB)</span></label>
                                                                <input
                                                                    type="file"
                                                                    className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                                    onChange={this.siteBackGroundChangeHandlerUpload}
                                                                    accept=".jpg, .jpeg, .png"
                                                                    disabled={this.state.isUploadDisabled}
                                                                />
                                                                <div className="text-danger error-msg">
                                                                    {this.state.error.backgroundImage}
                                                                </div>
                                                                {this.state.downloadLink && (
                                                                    <div style={{ paddingTop: "10px" }}>
                                                                        <a
                                                                            id="download"
                                                                            target="_blank"
                                                                            rel="noreferrer noopener"
                                                                            href={this.state.downloadLink}
                                                                            download={this.state.downloadFileName}
                                                                            style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                                        >
                                                                            Download
                                                                        </a>
                                                                        <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileName}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    )
                                                }
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Client ID <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.clientID} onChange={this.siteClinetIDHandaler} onBlur={this.checkIfClientIdAlreadyPresent} placeholder="Enter client name" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.clientID}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">System Modules <span className="text-danger">*</span></label>
                                                    <div className="add-select-main-div">
                                                        <Select
                                                            placeholder={`Select system modules`}
                                                            value={this.state.systemTypeValue}
                                                            options={this.state.systemTypesList}
                                                            onChange={this.systemTypesHandler}
                                                            isSearchable={true}
                                                        />
                                                    </div>
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.systemTypeValue}
                                                    </div>
                                                </div>
                                                {(this.state.systemTypeValue.label === "Ami Systems") && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Ami System Receiver Type <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select Ami system receiver type`}
                                                                value={this.state.amiSystemReceiverType}
                                                                options={this.state.amiSystemReceiverTypeList}
                                                                onChange={this.amiSystemReceiverTypesHandler}
                                                                isSearchable={true}
                                                                isMulti
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.amiSystemReceiverType}
                                                        </div>
                                                    </div>
                                                )
                                                }
                                                {(this.state.systemTypeValue.label === "Amr Systems") && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Amr System Receiver Type <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select Amr system receiver type`}
                                                                value={this.state.amrSystemReceiverType}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                                }
                                                {(this.state.systemTypeValue.label === "Ami + Remote Configuration") && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Ami + Remote Configuration System Receiver Type <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select Ami + Remote Configuration system receiver type`}
                                                                value={this.state.remoteSystemReceiverType}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                                }
                                                {(this.state.systemTypeValue.label === "Ami Systems" || this.state.systemTypeValue.label === "Amr Systems") && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Device type <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select device type`}
                                                                value={this.state.deviceTypeValue}
                                                                options={this.state.deviceTypesList}
                                                                onChange={this.deviceTypesHandler}
                                                                isSearchable={true}
                                                                isMulti={true}
                                                                isDisabled={this.state.deviceTypeDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.deviceTypeValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.systemTypeValue.label === "Ami + Remote Configuration" && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Device type <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select device type`}
                                                                value={this.state.deviceTypeValue}
                                                                options={this.state.deviceTypesListRemoteConfiguration}
                                                                onChange={this.deviceTypesHandler}
                                                                isSearchable={true}
                                                                isMulti={true}
                                                                isDisabled={this.state.deviceTypeDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.deviceTypeValue}
                                                        </div>
                                                    </div>
                                                )
                                                }

                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow") && this.state.systemTypeValue.label !== "Amr Systems") && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Flow Column Selection  <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select option`}
                                                                value={this.state.flowColumnSelecetionValue}
                                                                options={this.state.flowColumnSelecetionOptions}
                                                                onChange={this.flowColumnSelectionChangeHandler}
                                                                isSearchable={true}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.flowColumnSelecetionValue}
                                                        </div>
                                                    </div>
                                                )
                                                }

                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level")) && (
                                                    <div className="input-label-group col-md-6">
                                                        <label className="form-label">Level Column Selection  <span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select option`}
                                                                value={this.state.levelColumnSelecetionValue}
                                                                options={LEVEL_COLUMN_SELECTION_OPTIONS}
                                                                onChange={this.levelColumnSelectionChangeHandler}
                                                                isSearchable={true}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.levelColumnSelecetionValue}
                                                        </div>
                                                    </div>
                                                )
                                                }
                                            </div>
                                            <div className="row">
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Flow unit<span className="text-danger"> *</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.flowUnitValue}
                                                                options={this.state.flowUnitTypesList}
                                                                onChange={this.flowUnittypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.flowUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.flowUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Pressure")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Pressure unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.pressureUnitValue}
                                                                options={this.state.pressureUnitTypesList}
                                                                onChange={this.pressureUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.pressureUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.pressureUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Level unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.levelUnitValue}
                                                                options={this.state.levelUnitTypesList}
                                                                onChange={this.levelUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.levelUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.levelUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                                {(Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Temperature")) && (
                                                    <div className="input-label-group col-md-3">
                                                        <label className="form-label">Temperature unit<span className="text-danger">*</span></label>
                                                        <div className="add-select-main-div">
                                                            <Select
                                                                placeholder={`Select unit`}
                                                                value={this.state.temperatureUnitValue}
                                                                options={this.state.temperatureUnitTypesList}
                                                                onChange={this.temperatureUnitTypesHandler}
                                                                isSearchable={true}
                                                                isDisabled={this.state.temperatureUnitDisable}
                                                            />
                                                        </div>
                                                        <div className="text-danger error-msg">
                                                            {this.state.error.temperatureUnitValue}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Sub module feature <span className="text-danger"></span></label>
                                                    <div className="add-select-main-div">
                                                        <Select
                                                            placeholder={`Select sub module feature`}
                                                            value={this.state.subModuleFeatureValue}
                                                            options={this.state.subModuleFeatureList}
                                                            onChange={this.subModuleFeatureHandler}
                                                            isSearchable={true}
                                                            isMulti={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Client Name <span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input" value={this.state.clientName} onChange={this.siteClinetNameHandaler} placeholder="Enter client name" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.clientName}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Upload Site Primary Logo Image <span className="text-danger">(Max 2MB)</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.sitePrimaryLogoImageChangeHandler}
                                                        accept=".jpg, .jpeg, .png"
                                                    />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageType}
                                                    </div>
                                                    {this.state.primaryLogoImage && this.state.downloadLinkLogo1 && (
                                                        <div style={{ paddingTop: "10px" }}>
                                                            <a
                                                                id="download"
                                                                href={this.state.downloadLinkLogo1}
                                                                download={this.state.downloadFileNameLogo1}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                                style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                            >
                                                                Download
                                                            </a>
                                                            <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileNameLogo1}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Upload Site Secondary Logo Image <span className="text-danger">(Max 2MB)</span></label>
                                                    <input
                                                        type="file"
                                                        className="form-control brand-font p-3 placeholderColor add-meter-input"
                                                        onChange={this.siteSecondaryLogoImageChangeHandler}
                                                        accept=".jpg, .jpeg, .png"
                                                    />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.defaultBackgroundImageType}
                                                    </div>
                                                    {this.state.secondaryLogoImage && this.state.downloadLinkLogo2 && (
                                                        <div style={{ paddingTop: "10px" }}>
                                                            <a
                                                                id="download"
                                                                href={this.state.downloadLinkLogo2}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                                download={this.state.downloadFileNameLogo2}
                                                                style={{ color: 'blue', textDecoration: 'underline', fontSize: "15px" }}
                                                            >
                                                                Download
                                                            </a>
                                                            <span style={{ marginLeft: '10px', color: 'black', fontWeight: '200' }}>{this.state.downloadFileNameLogo2}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Backend URL</label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.backendURL} onChange={this.backendURLHandler} placeholder="Enter backend URL" />
                                                </div>
                                                <div className="input-label-group col-md-6">
                                                    <label className="form-label">Mark Meter Inactive After  <span className="text-danger">(Hours)  </span><span className="text-danger">*</span></label>
                                                    <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.siteInactive} onChange={this.siteInactiveHandler} placeholder="Enter Hours" />
                                                    <div className="text-danger error-msg">
                                                        {this.state.error.siteInactive}
                                                    </div>
                                                </div>
                                                {/* <div className="input-label-group col-md-6">
                                        <label className="form-label">Todays Consumption Readings Check After  <span className="text-danger">(Hours)  </span><span className="text-danger">*</span></label>
                                        <input className="form-control brand-font p-3 placeholderColor add-meter-input font-style" value={this.state.siteTodaysRedaingsToCheck} onChange={this.siteTodaysRedaingsToCheckHandler} placeholder="Enter Hours" />
                                        <div className="text-danger error-msg">
                                            {this.state.error.siteTodaysRedaingsToCheck}
                                        </div>
                                    </div> */}
                                                {
                                                    this.state.siteId && (
                                                        <div className="input-label-group col-md-12">
                                                            <label className="form-label">Site Login URL </label>
                                                            <div className='site-url-div'>
                                                                <CopyToClipboard text={`${WEB_APP_URL}/login/${this.state.clientID}`} onCopy={this.copyHandler}>
                                                                    <label className="form-label brand-font p-3 placeholderColor add-meter-input text-transform-none pl-0">
                                                                        {`${WEB_APP_URL}/login/${this.state.clientID}`}
                                                                        <br />
                                                                        <i className={`${COPY_ICON} list-table-icon copy-icon ${this.state.copiedIconClass}`}></i>
                                                                    </label>
                                                                </CopyToClipboard>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </>
                                    )}

                                    {this.state.activeTab === 'columnAccess' && (
                                        <div className="row mt-3 px-3">
                                            {/* Flow Column Permissions */}
                                            {Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Flow") && (
                                                this.state.flowColumnSelecetionValue.label === FLOW_COLUMN_SELECTION_TRUE_VALUE ? (
                                                    <div className="input-label-group col-md-12 mb-4">
                                                        <label className="form-label mb-3" style={{ fontSize: "16px", fontWeight: "600" }}>Flow Readings Column Permission</label>
                                                        <div className="column-permission-container">
                                                            <div className="column-permission-header">
                                                                <div>Column</div>
                                                                <div className="toggle-header">Admin</div>
                                                                <div className="toggle-header">Reader</div>
                                                            </div>
                                                            {flowColumns.map(column => (
                                                                <div key={column.field} className="column-permission-row">
                                                                    <div className="column-name">
                                                                        {column.label}
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.columnAccess.admin[column.field] || false}
                                                                                onChange={() => this.handleToggle("admin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.columnAccess.reader[column.field] || false}
                                                                                onChange={() => this.handleToggle("reader", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="col-md-12 text-center p-3 mb-4 border rounded bg-light">
                                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Please select "Yes" for Flow Column Selection in the Site Details tab to manage flow column access.</p>
                                                    </div>
                                                )
                                            )}

                                            {/* Level Column Permissions */}
                                            {Array.isArray(this.state.deviceTypeValue) && this.state.deviceTypeValue.some(device => device.value === "Level") && (
                                                this.state.levelColumnSelecetionValue?.label === LEVEL_COLUMN_SELECTION_TRUE_VALUE ? (
                                                    <div className="input-label-group col-md-12">
                                                        <label className="form-label mb-3" style={{ fontSize: "16px", fontWeight: "600" }}>Level Readings Column Permission</label>
                                                        <div className="column-permission-container">
                                                            <div className="column-permission-header" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                <div>Column</div>
                                                                <div className="toggle-header">Super Admin</div>
                                                                <div className="toggle-header">Admin</div>
                                                                <div className="toggle-header">Reader</div>
                                                            </div>
                                                            {levelColumns.map(column => (
                                                                <div key={column.field} className="column-permission-row" style={{ gridTemplateColumns: "2fr 1fr 1fr 1fr" }}>
                                                                    <div className="column-name">
                                                                        {column.label}
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.superadmin[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("superadmin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.admin[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("admin", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="column-toggle">
                                                                        <label className="switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.levelColumnAccess.reader[column.field] || false}
                                                                                onChange={() => this.handleLevelToggle("reader", column.field)}
                                                                            />
                                                                            <span className="slider"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="col-md-12 text-center p-3 border rounded bg-light">
                                                        <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Please select "Yes" for Level Column Selection in the Site Details tab to manage level column access.</p>
                                                    </div>
                                                )
                                            )}

                                            {/* Fallback if neither Flow nor Level is selected */}
                                            {(!Array.isArray(this.state.deviceTypeValue) || (!this.state.deviceTypeValue.some(device => device.value === "Flow") && !this.state.deviceTypeValue.some(device => device.value === "Level"))) && (
                                                <div className="col-md-12 text-center p-5">
                                                    <p className="text-muted" style={{ fontSize: "16px" }}>Please select "Flow" or "Level" as Device Type in the Site Details tab to manage column access.</p>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="btn-container">
                                    <button className="brand-button" onClick={this.addSiteHandler} >Submit</button>
                                    <button className="cancel_button" onClick={this.cancelHandler}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default CreateSitePage